import { UUID } from "crypto";

export interface IVacancyDetail {
    id: UUID;
    businessUnitId: UUID;
    title: string;
    city: string;
    company: string;
    deadline: Date;
    category: string;
    requirements: string[];
    jobDesc: string[];
    aboutBusinessUnit: string;
}

export type Vacancies = {
    id: string;
    iconUrl: string | null;
    title: string;
    businessUnitName: string;
    categoryName: string;
    city: string;
    endDate: string;
};
  
export type VacancyList = {
    vacancies: Vacancies[];
};

export interface ListOfVacancy {
    vacancies: Vacancy[];
    totalData: number;
}

export interface Vacancy {
    id: UUID;
    blobId: UUID;
    title: string;
    businessUnitId: UUID;
    businessUnitName: string;
    categoryName: string;
    city: string;
    endDate: Date;
}


export enum PopupTypes {
    ShowJobApply = 'showJobApply',
    ShowErrorPopup = 'showErrorPopup',
    ShowSuccessPopup = 'showSuccessPopup',
}